<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class="mt-4">
        <Activation />
        <b-row class="desktop">
            <b-col cols="3">
                <InterpreterSidebar class="mt-5" all='active' />
            </b-col>
            <b-col cols="9">
                <b-row class="head-box">
                    <b-col cols="12" md="4" class="">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon font-scale="0.99" icon="tag"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input v-model="fromLanguage" type="text" placeholder="From what language">
                            </b-form-input>
                        </b-input-group>
                    </b-col>
                    <b-col cols="12" md="4" class="">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon font-scale="0.99" icon="tag"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input v-model="toLanguage" type="text" placeholder="to what language ">
                            </b-form-input>
                        </b-input-group>
                    </b-col>
                    <b-col cols="12" md="4" class="btn-box">
                        <button class="btn btn-warning btn-culture">
                            <b-icon font-scale="0.99" icon="search"></b-icon>Search
                        </button>
                    </b-col>
                </b-row>
                <div class="mt-4" v-if="loading">
                    <content-loader :speed="2" :height="400" :width="600">
                        <circle cx="25" cy="112" r="15" />
                        <rect x="10" y="18" rx="0" ry="0" width="464" height="9" />
                        <rect x="497" y="10" rx="0" ry="0" width="144" height="144" />
                        <rect x="10" y="41" rx="0" ry="0" width="464" height="9" />
                        <rect x="10" y="65" rx="0" ry="0" width="364" height="9" />
                        <rect x="50" y="98" rx="0" ry="0" width="115" height="9" />
                        <rect x="50" y="115" rx="0" ry="0" width="115" height="10" />
                    </content-loader>
                </div>
                <p v-if="!loading" class="mt-4 mb-4 d-flex justify-content-between">
                    <span>
                        Per page:
                        <select class="" v-model="no_per_page" @change="getAllInterpreters(page)">
                            <option value="10" selected>10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select> items
                    </span>
                    <span>{{ page }} of {{ rows }} Interpreters</span>
                </p>
                <div v-if="!loading">
                    <div v-if="interpreters.length > 0">
                        <div v-for="(interpreter, index) in interpreters" :key="index">
                            <InterpreterCard :spec="interpreter.specializations[0].title" locationStatus="Online" :fromLanguage="interpreter.from_language" btnText="Details" :toLanguage="interpreter.to_language" torouteName="interpreter-details" showBookBtn="true" :routeId="interpreter.interpreter_id" :fromExperience="interpreter.from_lang_experience" :toExperience="interpreter.to_lang_experience" class="mb-4" :imgUrl="interpreter.photo" :description="interpreter.reason" :hireStatus="interpreter.hire_status" :hostName="hostName(interpreter)" :starRating="interpreter.average_ratings" @handleHire="openHireModal(interpreter)" />
                        </div>
                        <div>
                            <b-pagination v-model="page" :total-rows="rows" @change="getAllInterpreters" :per-page="no_per_page"></b-pagination>
                        </div>
                    </div>
                    <div v-else>
                        No listing created yet, be the first to <router-link class="culture-primary" to="/languages/interpreters/create"> create one </router-link>
                    </div>

                </div>

            </b-col>

        </b-row>
        <div class="mobile">
            <b-row>
                <b-col cols="3">
                    <InterpreterSidebar menuId="slidmenu" @handleOpen="openMenu" @handleHide="hideSidemenu" class="mt-5" all='active' />
                </b-col>
                <b-col cols="9">
                    <b-row class="head-box">
                        <b-col cols="12" class="">
                            <b-input-group class="">
                                <b-input-group-prepend is-text>
                                    <b-icon font-scale="0.99" icon="calendar2-date"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="text" placeholder="from language "></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" class="">
                            <b-input-group class="">
                                <b-input-group-prepend is-text>
                                    <b-icon font-scale="0.99" icon="globe"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="text" placeholder="to language "></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" class="btn-box">
                            <button class="btn btn-warning btn-culture">
                                <b-icon font-scale="0.99" icon="search"></b-icon>Search
                            </button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <div v-if="interpreters.length > 0">
                <p class="mb-4 mt-4">{{ interpreters.length }} results</p>
                <div v-for="(interpreter, index) in interpreters" :key="index">
                    <InterpreterCard :spec="interpreter.specializations[0].title" locationStatus="Online" :fromLanguage="interpreter.from_language" btnText="Details" :toLanguage="interpreter.to_language" torouteName="interpreter-details" showBookBtn="true" :routeId="interpreter.interpreter_id" :fromExperience="interpreter.from_lang_experience" :toExperience="interpreter.to_lang_experience" class="mb-4" :imgUrl="interpreter.photo" :description="interpreter.reason" :hireStatus="interpreter.hire_status" :hostName="hostName(interpreter)" :starRating="interpreter.average_ratings" @handleHire="openHireModal(interpreter)" />

                </div>
            </div>
        </div>
        <b-modal size="lg" id="profile-modal" hide-header centered hide-footer>
            <div class="row profile-contain" style="margin-left:0 !important">
                <b-col cols="8">
                    <div class="row p-3">
                        <b-col cols="4">
                            <p class="font12">Gender</p>
                            <p class="font16">
                                <b-icon font-scale="0.9" icon="person"></b-icon> {{ host.gender }}
                            </p>
                        </b-col>
                        <b-col cols="4"></b-col>
                        <b-col cols="4" v-if="host.nationality">
                            <p class="font12">Nationality</p>
                            <p class="font16">
                                <b-icon font-scale="0.9" icon="globe"></b-icon> {{ host.nationality.name }}
                            </p>
                        </b-col>
                    </div>
                    <div class="row p-3">
                        <b-col cols="8">
                            <p class="font12">State</p>
                            <p class="font16">
                                <b-icon font-scale="0.9" icon="globe"></b-icon> {{ host.state_residence }}
                            </p>
                        </b-col>
                        <b-col cols="4">
                            <p class="font12">Residence</p>
                            <p class="font16">
                                <b-icon font-scale="0.9" icon="globe"></b-icon> {{ host.country_residence }}
                            </p>
                        </b-col>

                    </div>
                    <div class="row p-3">
                        <b-col cols="8">
                            <p class="font12">Occupation</p>
                            <p class="font16">
                                <b-icon font-scale="0.9" icon="bag"></b-icon> {{ host.activities }}
                            </p>
                        </b-col>
                        <b-col cols="4">
                            <p class="font12">Username</p>
                            <p class="font16">
                                <b-icon font-scale="0.9" icon="clock"></b-icon> {{ host.username }}
                            </p>
                        </b-col>

                    </div>
                </b-col>
                <b-col cols="4" class="profile-contain ">
                    <div class="text-center mt-3">
                        <img :src="host.photo_thumb" style="width:110px;height:110px;border-radius:50%" class="p-3" alt="">
                        <div class="mt-3">{{ host.first_name }} {{ host.last_name }}</div>
                        <b-form-rating readonly show-value inline size="sm" v-model="host.rating"></b-form-rating>
                        <p class="font12">
                            {{ host.bio }}
                        </p>
                    </div>
                </b-col>
            </div>
        </b-modal>

    </b-container>
    <Footer />
</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import InterpreterCard from "@/components/InterpreterCard.vue";
import InterpreterSidebar from "@/components/InterpretersSidebar.vue";
import Activation from "@/components/Activation.vue";
import {
    ContentLoader
} from "vue-content-loader";

import axios from "axios";
import {
    getBaseUrl
} from "../../../../utils/common";
const base_url = getBaseUrl();
export default {
    name: 'listings',
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        InterpreterCard,
        InterpreterSidebar,
        ContentLoader,
        Activation,
        Footer
    },
    data: function () {
        return {
            headerText: "Interpreters",
            subText: "See all our skillful interpreters that are available in the system ",
            fadedText: "Language",
            defaultImage: require("../../../assets/images/prof-img.png"),
            loading: true,
            host: {},
            fromLanguage: '',
            toLanguage: '',
            listingTypeSelected: null,
            interpreters: [],
            no_per_page: 10,
            page: 1,
            pagination: {},
            interpreter: {

            },

        }
    },
    computed: {
        rows() {
            return this.pagination.total
        },
        currentUser: function () {
            return this.$store.getters.currentUser;
        },
    },
    mounted() {
        this.getAllInterpreters();
    },
    methods: {
        hostName(interpreter) {
            return interpreter.host.first_name + ' ' + interpreter.host.last_name;
        },
        dateFormat(classes, date) {
            if (!classes.disabled) {
                classes.disabled = date.getTime() < new Date()
            }
            return classes
        },
        viewProfile(host) {
            this.$bvModal.show("profile-modal")
            this.host = host
        },

        openMenu() {
            var slide = document.getElementById('slidmenu')
            slide.style.marginLeft = "calc(-40em + 10px)"
            if (slide.style.marginLeft === 'calc(-40em + 10px)') {
                slide.style.marginLeft = '-24px'

            } else {
                slide.style.marginLeft = "calc(-40em + 10px)"

            }
        },
        hideSidemenu() {
            var slide = document.getElementById('slidmenu')
            slide.style.marginLeft = "calc(-40em + 10px)"

        },
        async getAllInterpreters(page = 1) {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/language/interpreters`,
                    params: {
                        page: page,
                        no_per_page: this.no_per_page,
                    },
                    method: "GET",
                })
                this.loading = false;
                this.interpreters = resp.data.data;
                this.pagination = resp.data.meta
                
                this.interpreters.map((inp) => {
                   inp.specializations[0].title = inp.specializations[0].title === 's-lang'  ? 'Sign Language' : inp.specializations[0].title
                })
            } catch (error) {
                this.loading = false;
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },

    }

}
</script>

<style lang="scss" scoped>
.profile-contain {
    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.1);
}

.btn-culture {
    padding: 10px 60px !important;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        display: block;
        width: 100%;
        padding: 10px 15px !important;
        text-align: center;
    }

}

.form-control {
    height: calc(1.5em + 0.75rem + 15px) !important;

}

.form-control:focus {
    outline: none !important;
    box-shadow: none !important;
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.bi-search {
    margin-right: 1rem;
}

.custom-select .caret {
    padding-right: 10px;
}

.custom-control {
    margin: 0.7em auto
}

.btn-box {
    margin: 14px 0
}

.head-box {
    margin: 35px auto auto;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    border-radius: 5px;
    padding: 10px;
    background-color: #F6F7F7;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        margin: 0;
    }
}

.inner-header-box {
    padding: 20px;
    border-radius: 4px;
    cursor: pointer;
}

.inner-header-box:hover {
    background: #000;
    color: #fff;
    border-radius: 4px;
    transition: ease-in 0.3s;

}

.inner-header-box:hover .b-icon.bi {
    color: rgba(247, 177, 49, 1)
}

.sidecard {
    border-radius: 4px;
    padding: 16px !important;
    border: none !important;
}

.simple-range-slider {
    width: auto !important;

}

.flex {
    display: flex;
    justify-content: space-between;
}

#slidmenu {
    position: absolute;
    z-index: 99;
    background: #fff;
    margin-left: calc(-40em + 10px);
    width: 328%;
    top: 0px;
    padding-left: 16px;
    transition: all 0.4s ease-in-out;
}
</style>
